import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKotlinComponent } from './simple-icons-kotlin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKotlinComponent ],
    exports:      [ SimpleIconsKotlinComponent ],
    bootstrap:    []
})
export class SimpleIconsKotlinModule {}
